const styles = theme => ({
  root: {}
})

export default styles



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/scenes/Search/scenes/SavedSearches/scenes/Filters/styles.js